module.exports = __webpack_public_path__ + "img/mwd.57e8ad4c.png";